import "../../../styles/productView.scss";
import "../../../styles/productViewListItem.scss";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { HubOverviewListHeader, HubOverviewListItem } from "./HubOverviewListItem.jsx";
import Icon, { iconTypes } from "../../common/components/Icon";

import HubCustomerSortingList from "./HubCustomerSortingList";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

class HubOverviewList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            width: null,
        };
        this.containerNode = null;

        this.createDraggableProducts = this.createDraggableProducts.bind(this);
        this.prepareItems = this.prepareItems.bind(this);
        this.prepareDraggableItems = this.prepareDraggableItems.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.sortProducts = this.sortProducts.bind(this);
        this.sortCustomers = this.sortCustomers.bind(this);
    }

    onDragEnd(result) {
        const {
            updateHubProductSortOrder,
            dateIndex,
            thisWeek,
        } = this.props;

        // dropped outside the list
        if (!result.destination) {
            return;
        }

        //swap places
        updateHubProductSortOrder(result.source.index, result.destination.index, dateIndex, thisWeek);
    }

    prepareDraggableItems() {
        const drag = (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{width:"100%"}}
                        >
                            {
                                this.createDraggableProducts()
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>);
        return drag;
    }

    createDraggableProducts() {
        const {
            list,
            localization,
            setModal,
        } = this.props;

        const retNodes = [];

        for (let i = 0; i < list.length; i++) {
            const productId = list[i].productId;

            retNodes[retNodes.length] = (
                <Draggable key={`Un-${productId}`} draggableId={`Un-${productId}`} index={i}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <HubOverviewListItem
                                style={{backgroundColor: snapshot.isDragging?"#e8e9eb":"#f6f7f8"}}
                                key={i}
                                localization={localization}
                                product={list[i]}
                                setModal={setModal}
                            />
                        </div>
                    )}
                </Draggable>
            );
        }
        return retNodes;
    }

    prepareItems() {
        const {
            list,
            localization,
            setModal,
        } = this.props;

        const retNodes = [];

        for (let i = 0; i < list.length; i++) {
            retNodes[retNodes.length] = (
                <HubOverviewListItem
                    key={i}
                    localization={localization}
                    product={list[i]}
                    setModal={setModal}
                />);
        }
        return retNodes;
    }

    sortProducts(){
        this.props.setProductsSortingMode(!this.props.sortProducts);
    }

    sortCustomers() {
        this.props.setCustomersSortingMode(!this.props.sortCustomers);
    }


    render() {
        const {
            localization,
            height,
            customers,
            sortProducts,
            sortCustomers,
            updateHubCustomerSortOrder,
            dateIndex,
            thisWeek,
        } = this.props;

        const nodes = sortProducts ? this.prepareDraggableItems() : this.prepareItems();

        return (
            <React.Fragment>
                { sortCustomers ? (
                    <HubCustomerSortingList
                        localization={localization}
                        customers={customers}
                        updateHubCustomerSortOrder = {updateHubCustomerSortOrder}
                        dateIndex = {dateIndex}
                        thisWeek = {thisWeek}
                        height = {height}/>
                ) : (
                    <div style={{overflowX: "auto", overflowY: "hidden", height: height}}>
                        <div className={"hub-product-view-header-wrapper"} >
                            <HubOverviewListHeader localization={localization} customers={customers} />
                        </div>
                        <div className={"hub-product-view-items-wrapper"} style={{overflowY: "auto", height: height-45}}>
                            {nodes}
                        </div>
                    </div>    
                )}
                <div style={{padding:"right"}}>
                    <button className={"btn icon"} onClick={this.sortProducts} disabled={false}>
                        <Icon type={iconTypes.draggable}/>
                        {localization.text("hub", "overview" , sortProducts ? "endProductsSorting" : "sortProducts")}
                    </button>
                    <button className={"btn icon"}  onClick={this.sortCustomers} disabled={false}>
                        <Icon type={iconTypes.draggable}/>
                        {localization.text("hub", "overview" , sortCustomers ? "endCustomersSorting" : "sortCustomers")}
                    </button>
                </div>
            </React.Fragment>);
    }
}

HubOverviewList.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
    // If true a loading icon will be displayed
    isLoading: PropTypes.bool,
    // An array of products to be displayed
    list: PropTypes.array.isRequired,
    customers: PropTypes.array.isRequired,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func.isRequired,
    style: PropTypes.object,
    updateHubProductSortOrder: PropTypes.func.isRequired,
    updateHubCustomerSortOrder:  PropTypes.func.isRequired,
    sortProducts: PropTypes.bool.isRequired,
    sortCustomers: PropTypes.bool.isRequired,
    setProductsSortingMode: PropTypes.func.isRequired,
    setCustomersSortingMode : PropTypes.func.isRequired,
    dateIndex: PropTypes.number,
    thisWeek: PropTypes.bool,
};

export default HubOverviewList;
